var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "overlay-color": "grey darken-2",
        transition: "scroll-x-transition",
        "max-width": "700",
        "content-class": "overflowY-hidden",
        persistent: "",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "accent", attrs: { width: "700px" } },
        [
          _c(
            "v-card-title",
            {
              staticClass: "pageTitle",
              staticStyle: { "background-color": "#47bd96", color: "white" },
              style: _vm.$vuetify.breakpoint.xsOnly
                ? "text-align: center !important;"
                : "",
            },
            [_vm._v("Edit Chart")]
          ),
          _c(
            "div",
            { staticClass: "pa-4" },
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        staticClass: "mt-2",
                        staticStyle: { width: "300px" },
                        attrs: {
                          dense: "",
                          outlined: "",
                          label: "Chart Name",
                          disabled: !_vm.canAlter,
                        },
                        model: {
                          value: _vm.chartConfigurations.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.chartConfigurations, "name", $$v)
                          },
                          expression: "chartConfigurations.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    [
                      _c("v-autocomplete", {
                        staticClass: "mt-2",
                        staticStyle: { width: "300px" },
                        attrs: {
                          disabled:
                            _vm.chartConfigurations.type !==
                              _vm.VISUALIZATION_TYPES.CHART || !_vm.canAlter,
                          items: _vm.symbols,
                          "no-data-text":
                            "No common symbols in selected watchers",
                          dense: "",
                          outlined: "",
                          label: "Symbol",
                        },
                        model: {
                          value: _vm.chartConfigurations.symbols,
                          callback: function ($$v) {
                            _vm.$set(_vm.chartConfigurations, "symbols", $$v)
                          },
                          expression: "chartConfigurations.symbols",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    [
                      _c("v-select", {
                        staticClass: "mt-2",
                        staticStyle: { width: "300px" },
                        attrs: {
                          dense: "",
                          outlined: "",
                          items: _vm.watchers,
                          disabled: !_vm.canAlter,
                          "menu-props": { offsetY: true, maxHeight: "250" },
                          label: "Watchers",
                          "item-text": "name",
                          "item-value": "id",
                          multiple: "",
                        },
                        on: { change: _vm.recalculateSymbols },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "mb-0 char-lim-tabs" },
                                  [_c("div", [_vm._v(_vm._s(item.name))])]
                                ),
                              ]
                            },
                          },
                          {
                            key: "selection",
                            fn: function ({ item, index }) {
                              return [
                                index === 0
                                  ? _c("v-chip", [
                                      _c("span", [_vm._v(_vm._s(item.name))]),
                                    ])
                                  : _vm._e(),
                                index === 1
                                  ? _c("span", [
                                      _vm._v(
                                        " (+" +
                                          _vm._s(
                                            _vm.chartConfigurations.watchers
                                              .length - 1
                                          ) +
                                          " others) "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "prepend-item",
                            fn: function () {
                              return [
                                _c(
                                  "v-list-item",
                                  {
                                    staticStyle: {
                                      "max-height": "40px",
                                      "border-bottom": "1px solid #7f7f7f",
                                    },
                                    attrs: { ripple: "" },
                                    on: { click: _vm.selectAllWatchers },
                                  },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            class:
                                              _vm.chartConfigurations.watchers
                                                .length === _vm.watchers.length
                                                ? "primary--text"
                                                : _vm.$vuetify.theme.dark
                                                ? "white--text"
                                                : "black--text",
                                            staticStyle: {
                                              "font-size": "16px !important",
                                              "font-weight": "400",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.chartConfigurations.watchers
                                                  .length ===
                                                  _vm.watchers.length
                                                  ? "Deselect All"
                                                  : "Select All"
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.chartConfigurations.watchers,
                          callback: function ($$v) {
                            _vm.$set(_vm.chartConfigurations, "watchers", $$v)
                          },
                          expression: "chartConfigurations.watchers",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    [
                      _vm.isAdmin
                        ? _c(
                            "input-wrapper",
                            { attrs: { label: "Visibility" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: `${
                                    _vm.chartConfigurations.isPublic
                                      ? "Public"
                                      : "Private"
                                  }`,
                                  "hide-details": "",
                                  dense: "",
                                  disabled: !_vm.canAlter,
                                },
                                model: {
                                  value: _vm.chartConfigurations.isPublic,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.chartConfigurations,
                                      "isPublic",
                                      $$v
                                    )
                                  },
                                  expression: "chartConfigurations.isPublic",
                                },
                              }),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                { attrs: { small: "" } },
                                                on
                                              ),
                                              [_vm._v("fa fa-info-circle")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2313606731
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "Specify if the chart will also be visible to regular users or only to Admin and to the owner of the chart"
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mx-0 accent", attrs: { justify: "space-between" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 opacity-1-slow",
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialog = false
                    },
                  },
                },
                [_vm._v("Cancel ")]
              ),
              _c("v-spacer"),
              _c(
                "div",
                { on: { click: _vm.save } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-2 opacity-1-slow",
                      attrs: {
                        disabled:
                          _vm.chartConfigurations.symbols == null ||
                          !_vm.canAlter,
                        disable:
                          _vm.chartConfigurations.symbols == null ||
                          !_vm.canAlter,
                        color: "primary",
                      },
                    },
                    [_vm._v(" Save ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }